// there is a comment for what this returns where this function is called.
function getSamples(canvasWidth, canvasHeight, horizontalMargins, verticalMargins){
  const OFFSET_PX = 4; //test OFFSET_PX inside bleed and outside bleed.

  const innerHorizontalMargins = horizontalMargins + OFFSET_PX;
  const innerVerticalMargins = verticalMargins + OFFSET_PX;

  const trimWidth = canvasWidth - innerHorizontalMargins * 2;
  const trimHeight = canvasHeight - innerVerticalMargins * 2;

  const xOffset = innerHorizontalMargins;
  const yOffset = innerVerticalMargins;

  const REQ_SPACING = 10;
  const numHorizontalSamples = Math.ceil(trimWidth / REQ_SPACING);
  const numVerticalSamples = Math.ceil(trimHeight / REQ_SPACING);
  const horizontalSpacing = trimWidth / (numHorizontalSamples - 1)
  const verticalSpacing = trimHeight / (numVerticalSamples -1);

  const samples = [];

  for (let j=0; j<2; j++){
    const offsetSign = j==0 ? -1 : 1;
    const yPosition = j==0 ? yOffset : yOffset + trimHeight;

    for (let i=0; i<numHorizontalSamples; i++){
      const checkAgainst = [{
        x: Math.round(xOffset + i*horizontalSpacing),
        y: Math.round(yPosition + (OFFSET_PX * 2 * offsetSign))
      }];

      if (i==0){
        checkAgainst.push({
          x: Math.round(xOffset + i * horizontalSpacing - OFFSET_PX * 2),
          y: Math.round(yPosition)
        });
      }

      if (i === numHorizontalSamples - 1){
        checkAgainst.push({
          x: Math.round(xOffset + i * horizontalSpacing + OFFSET_PX * 2),
          y: Math.round(yPosition)
        });
      }

      samples.push({
        x:Math.round(xOffset + i*horizontalSpacing),
        y:Math.round(yPosition),
        o:checkAgainst
      });
    }
  }

  for (let j=0; j<2; j++){
    const offsetSign = j==0 ? -1: 1;
    const xPosition = j==0 ? xOffset : xOffset + trimWidth;
    for (let i=1; i<numVerticalSamples - 1; i++){
      samples.push({
        x:Math.round(xPosition),
        y:Math.round(yOffset + i * verticalSpacing),
        o:[{
          x: Math.round(xPosition + (OFFSET_PX * 2 * offsetSign)),
          y: Math.round(yOffset + i*verticalSpacing)
        }]
      });
    }
  }

  return samples;
}

//isWhite with small amount of tolerance
function isWhite(rgba){
  return (rgba[3] < 3 || rgba[0] > 252 && rgba[1] > 252 && rgba[2] > 252);
}

function isPointColored(ctx, x,y){
  return !isWhite(ctx.getImageData(
    Math.round(x * window.devicePixelRatio),
    Math.round(y * window.devicePixelRatio), 1, 1).data);
}

export default function getBleedPoints(fabricCanvas, ctx, horizontalMargins, verticalMargins, showThreshold = 0){

  const activeObject = fabricCanvas.getActiveObject();

  // hide the controls by setting them transparent
  // avoids false positives on the handles
  const controlsColorTypes = ['borderColor', 'cornerColor', 'cornerStrokeColor'];
  let prevControlsColors = [];
  if (activeObject){
    prevControlsColors = controlsColorTypes.map(controlsColorType => {
      const lastColor = activeObject[controlsColorType];
      activeObject[controlsColorType] = 'transparent';
      return lastColor;
    });
    fabricCanvas.renderAll();
  }


  /*
  getSamples returns:
   [{x:x, y:y,                           // sample points inside bleed
     o: [{x:x, y:y}, {x:x1, y:y1} ...],  // points to compare against outside of bleed
     ...
   ]
  */
  let samples = getSamples(fabricCanvas.getWidth(), fabricCanvas.getHeight(), horizontalMargins, verticalMargins);

  const badBleedDisplayPoints = [];
  // decorates samples with "isColored" for colored points inside bleed,
  // and "badBleed" for outer points if necessary
  samples.forEach(sample => {
    sample.isColored = isPointColored(ctx, sample.x, sample.y);
    if (sample.isColored){
      sample.o.forEach(checkAgainst => {
        checkAgainst.badBleed = !isPointColored(ctx, checkAgainst.x, checkAgainst.y);
        badBleedDisplayPoints.push(checkAgainst);
      })
    }
  });

  if (badBleedDisplayPoints.length > 0 && badBleedDisplayPoints.length <= showThreshold){
    console.log('hiding bleed points because there are only ' + badBleedDisplayPoints.length);
    badBleedDisplayPoints.forEach((displayPoint) => {
      displayPoint.badBleed = false;
    });
  }

  // return the controls colors to their original color
  if (activeObject){
    controlsColorTypes.forEach((controlsColorType, idx) => {
      activeObject[controlsColorType] = prevControlsColors[idx];
    });
    fabricCanvas.renderAll();
  }


  return samples;
}



// WEBPACK FOOTER //
// ./src/lib/getBleedPoints.js